import { React, useState } from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";

function CreateValidateTextField(props) {
  const { placeholder, value, setter, pattern, errorMessage, required, type, maxLength, disabled } = props;

  const [error, setError] = useState(false);

  const patternRegex = new RegExp(pattern);

  const handleChange = (event) => {
    if (event.target.value.length > maxLength) {
      setError(true);
      return;
    }
    setter(event.target.value);
    setError(false); // reset error when user changes input
  };

  const handleBlur = () => {
    if (value === null) {
      setError(true);
      return;
    }
    if (value.trim() === "") {
      if (!required) {
        setError(false);
        return;
      }
      setError(true);
      return;
    }
    if (!patternRegex) {
      setError(false);
      return;
    }
    if (patternRegex.test(value) && value.length === value.match(patternRegex)[0].length) {
      setError(false);
      return;
    }
    setError(true);
  };

  return (
    <TextField className="ValidateTextField [&>div]:rounded-xl [&>div]:h-11 [&>div]:bg-white [&>div]:border w-full"
      placeholder={placeholder}
      type={type}
      required={required}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      error={error}
      helperText={error ? errorMessage : ""}
      inputProps={{ maxLength: maxLength }}
      disabled={disabled} // This properly disables the TextField
      style={{ 
        backgroundColor: disabled ? "#e7e7e7" : "",
        fontStyle: disabled ? "italic" : "",
        cursor: disabled ? "not-allowed" : "",
      }}
    />
  );
}

CreateValidateTextField.propTypes = {
  value: PropTypes.string,
  setter: PropTypes.func,
  pattern: PropTypes.string,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
};

CreateValidateTextField.defaultProps = {
  value: "",
  setter: () => { },
  pattern: "",
  errorMessage: "",
  required: false,
  placeholder: "",
  type: "text",
  maxLength: 100,
  disabled: false,
};

export default CreateValidateTextField;
